(function () {

    "use strict";

    function workflowTrackingEventsService($resource,URL) {

        var self = this;
        
        self.resource = $resource(URL.URL +'/api/workflow/trackingevents/:idWorkflow/:idFileItem', { idWorkflow: '@idWorkflow', idFileItem: '@idFileItem' },
            {
                queryPaged: {
                    method: 'GET'
                },
                query: {
                    method: 'GET', isArray: true
                },
                update: {
                    method: 'PUT'
                }
            });

    }

    workflowTrackingEventsService.$inject = ["$resource","URL"];

    angular.module("sphforms.workflow").service("sphforms.workflowTrackingEventsService", workflowTrackingEventsService);

})();